<div class="card">
  <div class="card-body">
    <h4 class="mb-2">Patient</h4>
    <app-patient-search-form
      #patientSearchForm
      [formDisabled]="searchFormDisabled"
      [suggestedSearch]="suggestedSearch"
      (patientSearch)="onPatientSearch($event)"
      (resetSearch)="onReset()"
      />
    @if (!searchFormDisabled) {
      @if (!hasSearched) {
        <p class="mt-2 p-2 bg-light">Search for a patient above.</p>
      } @else {
        @if (refreshing) {
          <div><mat-spinner diameter="30" /></div>
        }
        @if (!refreshing && patients.length > 0) {
          <div class="mt-2">
            <h5>Choose Patient</h5>
            <div infiniteScroll (scrolled)="onPatientScrolled()" [infiniteScrollDisabled]="loadingMoreResults" [scrollWindow]="false" class="choose-patients">
              <app-patient-list [patients]="patients" (patientSelect)="onPatientSelect($event)" />
              @if (loadingMoreResults) {
                <div class="more-results-spinner">
                  <mat-spinner diameter="20" />
                </div>
              }
            </div>
          </div>
        } @else {
          @if (!refreshing) {
            <p class="mt-2 p-2 bg-light">No patients found.</p>
          }
        }
      }
    }
    @if (selectedPatient) {
      <div class="d-flex patient-selection mt-3">
        <app-patient-name [patient]="selectedPatient" [canViewPatient]="true" />
        <div class="small ms-3">{{ selectedPatient.gender | gender }}</div>
        <div class="text-danger ms-3 patient-clear" (click)="onPatientClear()">
          <fa-icon [icon]="['fas', 'times']" />
        </div>
      </div>
    }
  </div>
</div>
